export default __webpack_public_path__ + "static/media/Stalker's Spauld of Malice.7257238c.jpg";